<div class="position-relative">
  <ui-message class="font-md"
              *ngIf="giftCard?.isApplied"
              [showIcon]="false"
              [size]="'md'"
              [type]="'default'">
    <div class="d-flex">
      <i class="icon-check-bold discount-added-icon me-1"></i>
      <div>{{ giftCardMsg }}</div>
    </div>
  </ui-message>

  <div class="font-md {{discountAddedStyles}} discount-sibling-margin"
       *ngIf="appliedDiscount">
    <i class="icon-check-bold discount-added-icon"></i>
    {{ 'orderProcess.payment.promoCodeSection.discountAdded' | translate: { value: appliedDiscount.value } }}
  </div>

  <div class="discount-sibling-margin"
       [ngClass]="{'d-block': isPromoCollapsed && isApplyDiscountEnabled, 'd-none': !(isPromoCollapsed && isApplyDiscountEnabled)}">
    <div class="font-md {{firstStringStyle}}"
         [ngClass]="{'d-block': giftCardEnabled, 'd-none': !giftCardEnabled}"
         [innerHTML]="'orderProcess.payment.promoCodeSection.doHaveGiftCardOrPromoCode' | translate"></div>

    <div class="font-md {{firstStringStyle}}"
         [ngClass]="{'d-block': !giftCardEnabled, 'd-none': giftCardEnabled}"
         [innerHTML]="'orderProcess.payment.promoCodeSection.doYouHaveDiscountClickHere' | translate"></div>
  </div>

  <div class="discount-sibling-margin"
       *ngIf="!isPromoCollapsed && isApplyDiscountEnabled"
       [ngBusy]="{busy: busy, message: ('common.pleaseWait' | translate)}">
    <div class="fw-bold font-md mb-1"
         [translate]="'orderProcess.payment.promoCodeSection.addCode'">
      Add promo code
    </div>

    <div class="d-sm-flex align-items-center mb-1">
      <input type="text" class="form-control promo-input"
             (keydown.enter)="newDiscountCode ? applyDiscount(newDiscountCode) : null"
             [placeholder]="'orderProcess.payment.promoCodeSection.placeholder' | translate"
             [(ngModel)]="newDiscountCode"
             (ngModelChange)="codeChanged()" />

      <div class="ms-3 mt-xs-max-3 d-flex justify-content-end align-items-center">
        <button class="apply-btn btn btn-pink font-sm order-2 order-sm-1"
                (click)="applyDiscount(newDiscountCode)"
                [translate]="'orderProcess.payment.promoCodeSection.apply'">Apply
        </button>

        <div class="font-sm ml-sm-min-3 mr-sm-max-3 pointer order-1 order-sm-2"
             [translate]="'common.cancel'"
             (click)="cancel()">
          Cancel
        </div>
      </div>
    </div>

    <ui-message
      class="mt-3 font-md d-block"
      *ngIf="errorMsg"
      [showIcon]="false"
      [size]="'md'"
      [type]="'error'">
      {{ errorMsg }}
    </ui-message>
  </div>
</div>
